import useUrl from 'core/hooks/useUrl';
import AgencyViewComponent from '../../components/agencyView/AgencyView';
import ItineraryViewComponent from '../../components/itineraryView/ItineraryView';
import { withAuthenticationRequired } from 'react-oidc-context';

const Itinerary = () => {
  const { paramValue: courierParamValue, setParamValue: setCourierParamValue } =
    useUrl<number | null>('CourierId');

  const onCourierSelected = (courierId: number) => {
    setCourierParamValue(courierId);
  };

  return (
    <div className="flex h-full dark:bg-design-black dark:text-white">
      {courierParamValue ? (
        <ItineraryViewComponent />
      ) : (
        <AgencyViewComponent onCourierSelected={onCourierSelected} />
      )}
    </div>
  );
};

export default withAuthenticationRequired(Itinerary);
